import AddDocument from "./add-document";

export default AddDocument;
